import angular from 'angular';
import accountComponent from './account.component';
import accountService from './account.service';
import accountConfig from './account.config';

let accountModule = angular.module('app.account',[])
  .component('account', accountComponent)
  .service('AccountService', accountService)
  .config(accountConfig);

export default accountModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/account/account.js
 **/